import { router } from "@inertiajs/react"
import { taskOpenUrl, type TaskLinkTarget } from "@/lib/task-open-url"

export type BoardTaskOpener = (target: TaskLinkTarget & { id: number }, commentId: number | null) => boolean

let boardTaskOpener: BoardTaskOpener | null = null

export function registerBoardTaskOpener(opener: BoardTaskOpener | null): () => void {
  boardTaskOpener = opener
  return () => {
    if (boardTaskOpener === opener) boardTaskOpener = null
  }
}

export function openTaskLink(
  currentUrl: string,
  target: TaskLinkTarget & { id: number },
  commentId: number | null = null,
) {
  if (boardTaskOpener?.(target, commentId)) return
  router.visit(taskOpenUrl(currentUrl, target, commentId))
}
